<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">
                  Envio do comprovante de pagamento
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <div
              class="box-document"
              [ngClass]="{
                'white-bg': invoiceInput.files[0]?.name,
                'grey-bg': !invoiceInput.files[0]?.name
              }"
              (click)="invoiceInput.click()"
            >
              <input
                (change)="uploadDocumentsFile($event)"
                #invoiceInput
                style="display: none"
                type="file"
              />

              <div
                *ngIf="!invoiceInput.files[0]?.name"
                class="d-flex justify-content-center"
              >
                <img src="assets/image/upload-file.svg" />
              </div>
              <div
                *ngIf="!invoiceInput.files[0]?.name"
                class="d-flex justify-content-center text-center mg-top-32"
              >
                <span id="txt-format">
                  Arraste o comprovante para cá ou
                  <span class="blue">busque nos seus <br />arquivos</span>
                </span>
              </div>

              <div
                *ngIf="!invoiceInput.files[0]?.name"
                class="d-flex justify-content-center text-center"
              >
                <p id="txt-format">
                  Apenas os formatos .pdf .doc .png e .jpg são aceitos
                </p>
              </div>

              <div
                class="text-center mg-bottom-24"
                *ngIf="invoiceInput.files[0]?.name"
              >
                <div class="d-flex justify-content-center">
                  <img src="assets/image/pdf-icon.svg" />
                </div>

                <div class="mg-top-24">
                  <p id="txt-file">
                    {{ invoiceInput.files[0].name }}
                  </p>
                </div>

                <div class="mg-top-24">
                  <button
                    *ngIf="invoiceInput.files[0]?.name"
                    mat-button
                    class="button danger mg-top-24"
                  >
                    Remover documento
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal-footer-new"
          [style.justify-content]="isMobile ? 'center' : 'space-between'"
        >
          <button
            type="button"
            [style.width]="'134px'"
            class="btn-outline-dark btn"
            type="button"
            (click)="closeModal()"
          >
            Cancelar
          </button>
          <button
            type="button"
            [disabled]="!invoiceFile"
            (click)="openGenerateSuccessModal()"
            class="btn-footer btn"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
